import "@arco-design/web-react/es/Spin/style";
import _Spin from "@arco-design/web-react/es/Spin";
import React from 'react';
import loadable from '@loadable/component';
import styles from '../style/layout.module.less';

// https://github.com/gregberge/loadable-components/pull/226
function load(fn, options) {
  const Component = loadable(fn, options);
  Component.preload = fn.requireAsync || fn;
  return Component;
}
function LoadingComponent(props) {
  if (props.error) {
    console.error(props.error);
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.spin
  }, /*#__PURE__*/React.createElement(_Spin, null));
}
export default loader => load(loader, {
  fallback: LoadingComponent({
    pastDelay: true,
    error: false,
    timedOut: false
  })
});